import * as React from "react";
import { User } from "@models/user";
import { Button, Divider, Modal, Table, Avatar } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import Message from "@constants/message";
import UserForm from "@components/users/Form";
import { PaginationDefaultParams } from "../custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: User[];
  loading: boolean;
  deleteFn: (item: User) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const CategoriesTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteUser = (item: User): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      align:"right",
      dataIndex: "avatar_url",
      key: "avatar_url",
      render: (a, record) => (
        <Avatar
          size="small"
          src={record.avatar_url ? record.avatar_url : null}
          icon="user"
        />
      )
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`} />,
      width: 150,
      align:"center",
      dataIndex: "name",
      key: "name"
    },
    {
      title: <FormattedMessage id="app.username" defaultMessage={`Username`} />,
      dataIndex: "username",
      align:"center",
      key: "username"
    },
    {
      title: <FormattedMessage id="app.email" defaultMessage={`Email`} />,
      dataIndex: "email",
      align:"center",
      key: "email"
    },
    {
      title: <FormattedMessage id="app.mobile" defaultMessage={`Mobile`} />,
      dataIndex: "mobile",
      align:"center",
      key: "mobile"
    },
    {
      title: "",
      key: "actions",
      align:"left",
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/users/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteUser(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(CategoriesTable);
